export const ROOT = '/events';
export const URL_SEARCH = `${ROOT}/search`;
export const QUERY_PARAM_DATE = 'promptDatepicker';
export const QUERY_PARAM_PAGE = 'page';
export const QUERY_PARAM_LOCATION = 'location';
export const QUERY_PARAM_GEO_LOCATION_ID = 'geoLocationId';
export const QUERY_PARAM_DISTANCE = 'distance';
export const QUERY_PARAM_PREV_LOCATION = 'previousLocation';
export const QUERY_PARAM_ANY_LOCATION = 'course.session.anyLocation';

export const ANALYTICS_SITE_ID = 'opo';
export const ANALYTICS_PAGE_NAME = `${ANALYTICS_SITE_ID}:search`;
export const ANALYTICS_CONTENT_TYPE = 'non-commerce';
export const ANALYTICS_TEMPLATE_TYPE = 'outdoor school';

// Facets
export const FACETS_DATE_PICKER_NAME = 'classes_date_range';
export const FACETS_DATE_PICKER_SELECTED_NAME = null; // Might change in search-ui 'select_departure_date_range';
export const FACETS_ACTIVITIES_NAME = 'activity';
export const FACETS_LOCATION_NAME = 'location_search';
export const FACETS_LOCATION_API = '/events/geography/places/autocomplete';
export const FACETS_LOCATION_REGEX_IS_VALID = /^[^=+*!"{}[\]<>;$@/\\?%]*$/;
export const FACETS_LOCATION_REGEX_RADIUS = /\([Ww]ithin ([0-9]{1,3}) miles\)/;
